<template>
    <div class="controlContainer">
        <div class="controlContainerRow">
            <div class="innerRow">
                <div v-if="mappers.length > 1">
                    <select class="selectContainer" @change="chooseFile">
                        <option
                            v-for="{ name } in mappers"
                            :key="`${name}-file`"
                            :value="name"
                        >
                            {{ translationFiles[name] }}
                        </option>
                    </select>
                </div>
                <div
                    v-for="(map, index) in refmappers"
                    v-show="item === index"
                    :key="`${map.name}-repre`"
                >
                    <select
                        class="selectContainer"
                        @change="updateRepresentation"
                    >
                        <option value="0:-1:0">Hidden</option>
                        <option value="1:0:0">Points</option>
                        <option value="1:1:0">Wireframe</option>
                        <option value="1:2:0" selected>Surface</option>
                        <option value="1:2:1">Surface with Edge</option>
                    </select>
                </div>
                <div>
                    <select
                        ref="presetSelector"
                        class="selectContainer"
                        @change="applyPresetChange"
                    >
                        <option
                            v-for="name in rgbPresetNames"
                            :key="`${name}-preset`"
                            :value="name"
                            :selected="presetSelectorDefault === name"
                        >
                            {{ name }}
                        </option>
                    </select>
                </div>
            </div>

            <div class="innerRow">
                <div
                    v-for="(map, index) in refmappers"
                    v-show="item === index"
                    :key="`${map.name}-color`"
                >
                    <select class="selectContainer" @change="updateColorBy">
                        <option value=":">Cor Solida</option>
                        <option
                            v-for="opt in map.colorOptions"
                            :key="opt.value"
                            :value="opt.value"
                        >
                            {{ opt.label }}
                        </option>
                    </select>
                </div>
                <div
                    v-for="(map, index) in refmappers"
                    v-show="
                        map.showUpdateColorByComponent === true &&
                        item === index
                    "
                    :key="`${map.name}-comp`"
                >
                    <select
                        class="selectContainer"
                        @change="updateColorByComponent"
                    >
                        <option
                            v-for="t in map.compOpts"
                            :key="t[1]"
                            :value="t[1]"
                        >
                            {{ t[0] }}
                        </option>
                    </select>
                </div>
                <div
                    v-for="(map, index) in refmappers"
                    v-show="item === index"
                    :key="`${map.name}-opacity`"
                >
                    <input
                        class="opacity"
                        type="range"
                        value="100"
                        max="100"
                        min="1"
                        @change="updateOpacity"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vtkScalarBarActor from "@kitware/vtk.js/Rendering/Core/ScalarBarActor";
import vtkColorMaps from "@kitware/vtk.js/Rendering/Core/ColorTransferFunction/ColorMaps";

import {
    ColorMode,
    ScalarMode
} from "@kitware/vtk.js/Rendering/Core/Mapper/Constants";

export default {
    name: "ControlContainer",
    // eslint-disable-next-line vue/require-prop-types
    props: ["mappers", "renderer", "renderWindow"],
    data() {
        const TranslationMap = {
            "CN-Results": {
                MatId: "MatId",
                AvStressX: "Tensão X (MPa)",
                AvStressY: "Tensão Y (MPa)",
                AvStressZ: "Tensão Z (MPa)",
                AvPrincipalStress1: "Tensão principal I (MPa)",
                AvPrincipalStress2: "Tensão principal II (MPa)",
                AvPrincipalStress3: "Tensão principal III (MPa)",
                E_Young: "Módulo de elasticidade (MPa)",
                AvAccumulatedPlasticStrain: "Deformação plástica",
                Displacement: "Deslocamento (m)"
            },
            "Vertedouro-Results": {
                Displacement: "Deslocamento (m)",
                StressX: "Tensão X (Pa)",
                StressY: "Tensão Y (Pa)",
                StressZ: "Tensão Z (Pa)",
                PrincipalStress: "Tensão Principal",
                MatId: "MatId"
            },
            "BP-Results": {
                MatId: "MatId",
                StressX: "Tensão X (Pa)",
                StressY: "Tensão Y (Pa)",
                StressZ: "Tensão Z (Pa)",
                PrincipalStress: "Tensão Principal",
                E_Young: "Módulo de elasticidade (Pa)",
                Displacement: "Deslocamento (m)",
                WaterLevel: "Nível d'água"
            },
            "Barragem14julho-Results": {
                Displacement: "Deslocamento (m)",
                E_Young: "Módulo de elasticidade (MPa)",
                MatId: "MatId",
                PrincipalStress: "Tensão Principal (MPa)",
                StressX: "Tensão X (MPa)",
                StressY: "Tensão Y (MPa)",
                StressZ: "Tensão Z (MPa)"
            }
        };

        const translationComponent = {
            1: "X",
            2: "Y",
            3: "Z"
        };

        const translationFiles = {
            "Vertedouro-Results": "vertedouro",
            "BP-Results": "Barragem"
        };
        return {
            skipRow: false,
            compOpts: [],
            translationFiles,
            translationComponent,
            activeArray: "",
            refmappers: this.mappers.map(({ mapper, name: n, ...m }) => {
                const source = mapper.getInputData();
                const scalars = source.getPointData().getScalars();
                return {
                    ...m,
                    mapper,
                    name: n,
                    source,
                    activeArray: "",
                    compOpts: [],
                    dataRange: [].concat(scalars ? scalars.getRange() : [0, 1]),
                    showUpdateColorByComponent: false,
                    colorOptions: [
                        ...source
                            .getPointData()
                            .getArrays()
                            .filter(a => !a.getName().includes("vtkOriginal"))
                            .map(a => {
                                const name = a.getName();
                                return {
                                    label: `(p) ${
                                        TranslationMap[n][name] || name
                                    }`,
                                    value: `PointData:${name}`
                                };
                            }),
                        ...source
                            .getCellData()
                            .getArrays()
                            .filter(a => !a.getName().includes("vtkOriginal"))
                            .map(a => {
                                const name = a.getName();
                                return {
                                    label: `(c) ${
                                        TranslationMap[n][name] || name
                                    }`,
                                    value: `CellData:${name}`
                                };
                            })
                    ]
                };
            }),
            mapper: this.mappers[0].mapper,
            TranslationMap,
            scalarBarActor: vtkScalarBarActor.newInstance(),
            rgbPresetNames: vtkColorMaps.rgbPresetNames,
            item: 0,
            presetSelectorDefault: "erdc_rainbow_bright"
        };
    },
    mounted() {
        window.addEventListener("resize", this.onResize);
        this.renderer.addActor(this.scalarBarActor);
        this.scalarBarActor.setScalarsToColors(
            this.mappers[this.item].mapper.getLookupTable()
        );
    },
    methods: {
        onResize() {
            window.innerWidth > 950
                ? (this.skipRow = true)
                : (this.skipRow = false);
        },
        chooseFile(event) {
            const index = this.mappers.findIndex(
                ({ name }) => name === event.target.value
            );
            if (index >= 0) {
                this.item = index;
                this.mapper = this.mappers[index].mapper;
            }
        },
        updateRepresentation() {
            const [
                visibility,
                representation,
                edgeVisibility
            ] = event.target.value.split(":").map(Number);
            this.refmappers[this.item].actor
                .getProperty()
                .set({ representation, edgeVisibility });
            this.refmappers[this.item].actor.setVisibility(!!visibility);
            this.renderWindow.render();
        },
        updateOpacity(event) {
            const opacity = Number(event.target.value) / 100;
            this.refmappers[this.item].actor.getProperty().setOpacity(opacity);
            this.renderWindow.render();
        },
        applyPresetChange(event) {
            this.applyPreset(event.target);
        },
        applyPreset(target) {
            const preset = vtkColorMaps.getPresetByName(target.value);
            this.refmappers.forEach(({ dataRange, lookupTable }) => {
                lookupTable.applyColorMap(preset);
                lookupTable.setMappingRange(dataRange[0], dataRange[1]);
                lookupTable.updateRange();
            });
            this.renderWindow.render();
        },
        setShowUpdateColorByComponent(show) {
            const index = this.refmappers.findIndex(
                ({ mapper }) => mapper === this.mapper
            );
            if (index >= 0) {
                this.refmappers[index].showUpdateColorByComponent = show;
            }
        },
        updateColorBy(event) {
            const item = this.refmappers[this.item];
            const [location, colorByArrayName] = event.target.value.split(":");
            const interpolateScalarsBeforeMapping = location === "PointData";
            let colorMode = ColorMode.DEFAULT;
            let scalarMode = ScalarMode.DEFAULT;
            const scalarVisibility = location.length > 0;
            if (scalarVisibility) {
                const newArray = item.source[`get${location}`]().getArrayByName(
                    colorByArrayName
                );
                item.activeArray = newArray;
                const newDataRange = newArray.getRange();
                item.dataRange[0] = newDataRange[0];
                item.dataRange[1] = newDataRange[1];
                colorMode = ColorMode.MAP_SCALARS;
                scalarMode =
                    location === "PointData"
                        ? ScalarMode.USE_POINT_FIELD_DATA
                        : ScalarMode.USE_CELL_FIELD_DATA;

                const numberOfComponents = item.activeArray.getNumberOfComponents();
                if (numberOfComponents > 1) {
                    // always start on magnitude setting
                    if (item.mapper.getLookupTable()) {
                        const lut = item.mapper.getLookupTable();
                        lut.setVectorModeToMagnitude();
                    }
                    this.setShowUpdateColorByComponent(true);
                    item.compOpts = [["Magnitude", -1]];
                    while (item.compOpts.length <= numberOfComponents) {
                        item.compOpts.push([
                            `${
                                this.translationComponent[item.compOpts.length]
                            }`,
                            item.compOpts.length - 1
                        ]);
                    }
                } else {
                    this.setShowUpdateColorByComponent(false);
                }
                this.scalarBarActor.setAxisLabel(colorByArrayName);
                this.scalarBarActor.setVisibility(true);
            } else {
                this.setShowUpdateColorByComponent(false);
                this.scalarBarActor.setVisibility(false);
            }
            item.mapper.set({
                colorByArrayName,
                colorMode,
                interpolateScalarsBeforeMapping,
                scalarMode,
                scalarVisibility
            });

            this.applyPreset(this.$refs.presetSelector);
        },

        updateColorByComponent(event) {
            const item = this.refmappers[this.item];
            if (item.mapper.getLookupTable()) {
                const lut = item.mapper.getLookupTable();
                item.mapper.setColorModeToMapScalars();
                if (event.target.value === "-2") {
                    item.mapper.setColorModeToDirectScalars();
                } else if (event.target.value === -1) {
                    lut.setVectorModeToMagnitude();
                } else {
                    lut.setVectorModeToComponent();
                    lut.setVectorComponent(Number(event.target.value));
                    const newDataRange = item.activeArray.getRange(
                        Number(event.target.value)
                    );
                    item.dataRange[0] = newDataRange[0];
                    item.dataRange[1] = newDataRange[1];
                    item.lookupTable.setMappingRange(
                        item.dataRange[0],
                        item.dataRange[1]
                    );
                    lut.updateRange();
                }
                this.renderWindow.render();
            }
        }
    }
};
</script>

<style scoped>
.controlContainerRow {
    max-width: 100%;
    display: flex;
}

.innerRow {
    display: flex;
    flex-direction: row;
}

@media (min-width: 425px) {
    .controlContainer {
        position: absolute;
        z-index: 1;
    }

    .selectContainer {
        color: white;
    }
}

@media (max-width: 424px) {
    .selectContainer {
        color: black;
    }
}

@media (min-width: 950px) {
    .controlContainerRow {
        flex-direction: row;
    }
}

@media (max-width: 949px) {
    .opacity {
        width: 100px;
    }

    .controlContainerRow {
        flex-direction: column;
    }
}

.selectContainer {
    width: 10%;
    background: transparent;
    border: none;
    margin: 5px;
    z-index: 1;
    max-width: 100px;
    min-width: 100px;
}

.selectContainer > option {
    color: black;
}
</style>
